import "../App.css";
import "./Pagination.css";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { LoadingPage } from "../loading/LoadingPage";
import { NavigationBar } from "../navigation/NavigationBar";

import { useParams, Link } from "react-router-dom";
import { call, home } from "../service/ApiService";
import {
  Container,
  List,
  Paper,
  //Grid,
  // Button,
  // AppBar,
  // Toolbar,
  //Typography,
  ListItem,
  ListItemText,
  InputBase,
  Checkbox,
  ListItemSecondaryAction,
  IconButton,
  Button,
} from "@mui/material";
//import { Pages } from "@mui/icons-material";

export const Pagination = ({ totalPage, limit, pages, setPages }) => {
  /*
  return (
    <div className="paging">
      <p>
        {"현재 페이지 :"} {pages}
        {"currentPageArray : "} {currentPageArray}
        {totalPageArray}
      </p>
      <span>
        <Button onClick={() => setPages(1)}>1</Button>
      </span>{" "}
      <span>
        <Button onClick={() => setPages(2)}>2</Button>
      </span>{" "}
      <span>
        <Button onClick={() => setPages(3)}>3</Button>
      </span>{" "}
    </div>
  );
    */

  //const [numPages, setNumPages] = useState(Math.ceil(totalPage / limit));

  const numPages = limit;
  //const numPages = Math.ceil(totalPage / limit);
  return (
    <div>
      <p>
        {"현재 페이지 :"} {pages}
      </p>
      <div className="nav">
        <Button onClick={() => setPages(pages - 1)} disabled={pages === 1}>
          &lt;{"<<"}
        </Button>
        {Array(numPages)
          .fill()
          .map((unused, i) => (
            <Button
              key={Math.floor((pages - 1) / limit) * 10 + i + 1}
              onClick={() =>
                setPages(Math.floor((pages - 1) / limit) * 10 + i + 1)
              }
              aria-current={
                pages === Math.floor((pages - 1) / limit) * 10 + i + 1
                  ? "page"
                  : undefined
              }
              disabled={
                Math.floor((pages - 1) / limit) * 10 + i + 1 > totalPage
              }
            >
              {Math.floor((pages - 1) / limit) * 10 + i + 1 > totalPage
                ? ""
                : Math.floor((pages - 1) / limit) * 10 + i + 1}
              {}
            </Button>
          ))}
        <Button
          onClick={() => setPages(pages + 1)}
          disabled={pages >= totalPage}
        >
          {">>"}&gt;
        </Button>
      </div>
    </div>
  );
};

export default Pagination;
